import { QuestConsolidatedReportType } from '@/core/domain/questReport/Reports/Consolidated/Consolidated.types';
import { Checkbox, Form } from 'antd';
import { useIntl } from 'react-intl';

import './consolidatedCheckBoxs.less';

const ConsolidatedCheckBoxs: React.FC = () => {
  const intl = useIntl();

  return (
    <Form.Item shouldUpdate noStyle>
      {({ getFieldValue }) => {
        const reportType = getFieldValue('reportType');

        return (
          <div className="consolidated-checkboxs">
            <Form.Item
              noStyle
              name="parts"
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.checkbox.parts',
                })}
              </Checkbox>
            </Form.Item>

            <Form.Item noStyle name="consumables" valuePropName="checked">
              <Checkbox>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.checkbox.consumable',
                })}
              </Checkbox>
            </Form.Item>

            {reportType === QuestConsolidatedReportType.synthetic && (
              <Form.Item
                noStyle
                name="showPartsWithNoMovement"
                valuePropName="checked"
                initialValue={true}
              >
                <Checkbox>
                  {intl.formatMessage({
                    id: 'consolidatedReportStock.form.checkbox.displayNonMovingParts',
                  })}
                </Checkbox>
              </Form.Item>
            )}

            <Form.Item noStyle name="hideZeroStock" valuePropName="checked">
              <Checkbox>Ocultar peças com estoque zero</Checkbox>
            </Form.Item>

            <Form.Item
              noStyle
              name="hideInventoryAndCorrectionMovimentation"
              valuePropName="checked"
              initialValue={true}
            >
              <Checkbox>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.checkbox.hideInventoryMovementAndStockCorrection',
                })}
              </Checkbox>
            </Form.Item>

            <Form.Item
              noStyle
              name="hideInactiveProducts"
              valuePropName="checked"
            >
              <Checkbox>
                {intl.formatMessage({
                  id: 'consolidatedReportStock.form.checkbox.hideInactiveProductsInTheRegister',
                })}
              </Checkbox>
            </Form.Item>
          </div>
        );
      }}
    </Form.Item>
  );
};

export default ConsolidatedCheckBoxs;
